import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useTestId from '@ori/testid-generator';
import { ArrowLeftThin, ArrowRightThin } from '@ori-ui/icons';
import { useState, useCallback } from 'react';
import { NextArrow, PreviousArrow } from "./styles";
import { shouldShowNextArrow, shouldShowPreviousArrow, getIndex } from "./utils";
import { CAROUSEL_NEXT_ARROW, CAROUSEL_PREVIOUS_ARROW } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavigationArrows = function NavigationArrows(_ref) {
  var _instanceRef$current;
  var instanceRef = _ref.instanceRef,
    lastSlideVisible = _ref.lastSlideVisible,
    slider = _ref.slider,
    slidesCount = _ref.slidesCount,
    navigation = _ref.navigation;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAtTheEnd = _useState2[0],
    setIsAtTheEnd = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isAtTheStart = _useState4[0],
    setIsAtTheStart = _useState4[1];
  var currentSlide = (_instanceRef$current = instanceRef.current) === null || _instanceRef$current === void 0 ? void 0 : _instanceRef$current.track.details.rel;
  var createHandler = useCallback(function (type) {
    return function (event) {
      var _instanceRef$current2;
      event.stopPropagation();
      var index = getIndex({
        instanceRef: instanceRef,
        isAtTheEnd: isAtTheEnd,
        isAtTheStart: isAtTheStart,
        setIsAtTheEnd: setIsAtTheEnd,
        setIsAtTheStart: setIsAtTheStart,
        slider: slider,
        slidesCount: slidesCount,
        type: type
      });
      (_instanceRef$current2 = instanceRef.current) === null || _instanceRef$current2 === void 0 || _instanceRef$current2.moveToIdx(index);
    };
  }, [instanceRef, isAtTheEnd, isAtTheStart, slider, slidesCount]);
  var onNextClick = createHandler('next');
  var onPreviousClick = createHandler('previous');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldShowPreviousArrow({
      currentSlide: currentSlide,
      slider: slider
    }) ? /*#__PURE__*/_jsx(PreviousArrow, {
      "data-testid": getTestId(CAROUSEL_PREVIOUS_ARROW),
      size: navigation === null || navigation === void 0 ? void 0 : navigation.size,
      onClick: onPreviousClick,
      children: /*#__PURE__*/_jsx(ArrowLeftThin, {})
    }) : null, shouldShowNextArrow({
      lastSlideVisible: lastSlideVisible,
      slidesCount: slidesCount,
      currentSlide: currentSlide,
      slider: slider
    }) ? /*#__PURE__*/_jsx(NextArrow, {
      "data-testid": getTestId(CAROUSEL_NEXT_ARROW),
      size: navigation === null || navigation === void 0 ? void 0 : navigation.size,
      onClick: onNextClick,
      children: /*#__PURE__*/_jsx(ArrowRightThin, {})
    }) : null]
  });
};
//# sourceMappingURL=NavigationArrows.js.map